// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__HSbxc","container":"container__7TiXq","emptyPage":"emptyPage__ZaKiY","image":"image__WAnWO","desc":"desc__C+0d+"};